import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import DeleteAutomationModal from 'modules/automations/components/DeleteAutomationModal'

import { useCurrentAutomationRoute } from './details/currentRoute'

const DeleteAutomationModalPage = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { id } = useStrictParams<'id'>()

  const route = useCurrentAutomationRoute()

  const onClose = () => {
    navigate(route.fullPath({ id }))
  }

  const onSuccess = () => {
    navigate(navigation.settings.automations.fullPath())
  }

  return <DeleteAutomationModal automationId={Number(id)} onClose={onClose} onSuccess={onSuccess} />
}

export default DeleteAutomationModalPage
